// src/modules/app-views/_apps/appsindico/parkingSpots/pages/Init/components/tableColumns/numberColumn.jsx
import translateX from 'utils/translateX';

function numberColumn(buildColumnProps, options = {}) {
  const {
    key = 'number',
    title = 'number',
    dataIndex = 'number',
    width = 120,
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    ...buildColumnProps(dataIndex, columnProps),
    render: text => {
      return text || '-';
    },
  };
}

export default numberColumn;
